module.exports = __webpack_public_path__ + "static/media/logo.3c77280b.png";